// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_PromotedResultsBadge.scss
// module id = 681
// module chunks = 68 88